'use client';

import Link from "next/link";
import { Button } from "@repo/ui";
import { ArrowRight, CheckCircle } from "lucide-react";
import { BackgroundLayers } from "@/components/ui/BackgroundLayers";
import { useTranslation } from '@/lib/i18n/use-translation';

const CTA = () => {
  const { t } = useTranslation();

  const benefits = [
    t('marketingLanding.cta.benefits.noCreditCard'),
    t('marketingLanding.cta.benefits.freeTrial'),
    t('marketingLanding.cta.benefits.cancelAnytime'),
    t('marketingLanding.cta.benefits.supportIncluded'),
  ];

  return (
    <BackgroundLayers variant="subtle" className="py-24">
      <div className="container">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-6 text-foreground">
            {t('marketingLanding.cta.title')}
          </h2>
          <p className="text-lg leading-8 text-muted-foreground mb-8 max-w-2xl mx-auto">
            {t('marketingLanding.cta.subtitle')}
          </p>

          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {benefits.map((benefit) => (
              <div key={benefit} className="flex items-center gap-2 text-sm text-muted-foreground">
                <CheckCircle className="h-4 w-4 text-brand-yellow-600 dark:text-brand-yellow-400" />
                {benefit}
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-layered">
              <Link href="/sign-up-landing">
                {t('marketingLanding.cta.primaryButton')}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button variant="outline" size="lg" asChild className="border-2">
              <Link href="/sign-up-landing">
                {t('marketingLanding.cta.secondaryButton')}
              </Link>
            </Button>
          </div>

          <div className="mt-12 pt-8 border-t border-border/50">
            <p className="text-sm text-muted-foreground">
              {t('marketingLanding.cta.trustLine')}
            </p>
          </div>
        </div>
      </div>
    </BackgroundLayers>
  );
};

export default CTA;
